module.exports = __webpack_public_path__ + "media/images/flags/64/Puerto-Rico-f17afe73b15ddfb63d024d83cf0af44d.png";